<script lang="ts">
    import WidthBox from "../../components/WidthBox.svelte";
    import Header from "../../components/Header.svelte";
    import House from "../../components/House.svelte";
    import { t } from "@lernetz/svelte-translate";
    import { setupSharedProps } from "../../services";

    export let houses;

    setupSharedProps();

</script>


<Header title={$t("houses")} />
<WidthBox>
    <div class="mt-112">
        <div class="text-almost-black text-16">{$t("choose-house")}</div>
        <div class="mt-32 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-16 sm:gap-24 content-center">
            {#each houses as house}
                <House model={house} />
            {/each}
        </div>
    </div>
</WidthBox>
